import { TableRow } from "@material-ui/core"
import { Backdrop, Menu, MenuItem, styled, TableCell, Typography, useTheme } from "@mui/material"
import React, { useEffect, useState } from "react"
import MoreHorizIcon from "@mui/icons-material/MoreHoriz"
import styles from "../../Quiz.module.scss"
import { useHistory } from "react-router-dom"
import { useDispatch } from "react-redux"
import { capitalize, getFormattedDate } from "helpers/functions"
import { marketingActions } from "redux/marketing/slice/user"

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: "12px 24px"
}))

const ContestRow = ({ row, columns }) => {
  const dispatch = useDispatch()
  const theme = useTheme()
  const history = useHistory()
  const [anchorEl, setAnchorEl] = useState(false)
  const openMenu = Boolean(anchorEl)

  const formattedDate = getFormattedDate(row.creation_date)

  const getStatusStyles = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return { color: theme.palette.green.main }
      case "draft":
        return { color: theme.palette.orange.main }
      case "published":
        return { color: theme.palette.green.light }
      default:
        return { color: theme.palette.text.primary }
    }
  }

  const onOptionsClick = (e) => {
    e.stopPropagation()
    setAnchorEl(e.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const editContest = () => {
    dispatch(marketingActions.setWeeklyQuizId(row.id))
    history.push("/learning_development/dashboard/weekly-challenge/weekly-quiz/edit")
  }

  const viewTriviaContest = () => {
    dispatch(marketingActions.setWeeklyQuizId(row.id))
    history.push("/learning_development/dashboard/weekly-challenge/weekly-quiz/view-weekly-quiz")
  }

  const checkStatus = () => {
    if (row?.status?.toLowerCase() === "published" || row?.status?.toLowerCase() === "completed") {
      return new Date(row?.start_date) > new Date()
    }
    return true
  }

  useEffect(() => {
    dispatch(marketingActions.setWeeklyQuizId(""))
    dispatch(marketingActions.setWeeklyQuizData({}))
  }, [])

  return (
    <>
      <TableRow>
        <TableCell>
          <Typography align={columns?.[0]?.align} variant="body1Regular">
            {row.name}
          </Typography>
        </TableCell>
        <TableCell align={columns?.[1]?.align}>
          <Typography variant="body1Regular">{formattedDate}</Typography>
        </TableCell>
        <TableCell align={columns?.[2]?.align}>
          <Typography sx={() => getStatusStyles(row.status)} variant="body1Regular">
            {capitalize(row.status)}
          </Typography>
        </TableCell>
        <TableCell align="center" onClick={(e) => e.stopPropagation()}>
          <span onClick={onOptionsClick} className={styles.actionBtnCtr}>
            <MoreHorizIcon
              sx={() => ({
                height: "24px",
                width: "24px"
              })}
            />
          </span>
          <Backdrop sx={{ color: "#fff", zIndex: 1300 }} open={openMenu} onClick={handleMenuClose}>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  marginTop: "15px",
                  backgroundColor: theme.palette.background.default,
                  borderRadius: "12px",
                  "& .MuiList-root": {
                    backgroundColor: theme.palette.background.default,
                    width: "225px",
                    boxSizing: "border-box",
                    padding: "10px 0"
                  }
                }
              }}>
              <StyledMenuItem onClick={viewTriviaContest}>
                <Typography variant="body1Regular">View</Typography>
              </StyledMenuItem>
              {checkStatus() && (
                <StyledMenuItem onClick={editContest}>
                  <Typography variant="body1Regular">Edit</Typography>
                </StyledMenuItem>
              )}
            </Menu>
          </Backdrop>
        </TableCell>
      </TableRow>
    </>
  )
}

export default ContestRow
